import { createFileRoute } from '@tanstack/react-router'
import {
  ADMIN_ENTITLEMENT_FILTER_KEYS,
  ADMIN_ENTITLEMENT_SORT_IDS,
} from '@/features/entitlements/components/entitlements/admin-entitlements-columns'
import { AdminEntitlementsPage } from '@/features/entitlements/pages/admin-entitlements-page'
import { createTableSearchSchema } from '@/lib/data-table/search-schema'

const entitlementsSearchSchema = createTableSearchSchema({
  defaultPageSize: 20,
  sortIds: ADMIN_ENTITLEMENT_SORT_IDS,
  filterKeys: ADMIN_ENTITLEMENT_FILTER_KEYS,
})

export const Route = createFileRoute('/entitlements')({
  staticData: { title: 'Harmoni+' },
  validateSearch: entitlementsSearchSchema,
  component: AdminEntitlementsPage,
})
